'use client';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

import { useT } from '@/hooks';
import { UserMenuLinkItem } from '@/types';

interface UserMenuItemProps {
  item: UserMenuLinkItem;
  onClick?: (path?: string) => void;
  color?: string;
  isSecondary?: boolean;
  sx?: SxProps<Theme>;
}

export const UserMenuItem = ({
  item,
  onClick,
  color,
  isSecondary = false,
  sx = {},
}: UserMenuItemProps) => {
  const { t } = useT();
  const handleClick = () => {
    if (onClick) {
      onClick(item.path);
    }
  };

  return (
    <MenuItem
      onClick={handleClick}
      sx={{
        py: 0.85,
        px: 1.75,
        borderRadius: '10px',
        mx: 1,
        mb: 0.25,
        color: color || 'inherit',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          bgcolor: (theme) =>
            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
          transform: 'translateX(4px)',
          '& .MuiListItemIcon-root': {
            color: color || 'primary.main',
          },
        },
        ...sx,
      }}
    >
      {item.icon && (
        <ListItemIcon
          sx={{
            minWidth: 36,
            color: color || 'text.secondary',
            transition: 'color 0.2s ease',
          }}
        >
          {item.icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={t(item.label)}
        primaryTypographyProps={{
          fontSize: '0.875rem',
          fontWeight: isSecondary ? 400 : 500,
          color: color || (isSecondary ? 'text.secondary' : 'text.primary'),
        }}
      />
    </MenuItem>
  );
};
